import { Controller } from "@hotwired/stimulus"

// A video sample has to live on a platform that hosts video, so picking that
// link type narrows the platform select to those and clears any selection the
// new type no longer allows.
export default class extends Controller {
  static targets = ["kind", "platform"]
  static values = { videoSampleKind: String, videoSamplePlatforms: Array }

  connect() {
    this.filter()
  }

  filter() {
    const videoOnly = this.kindTarget.value === this.videoSampleKindValue

    this.platformTarget.querySelectorAll("option").forEach((option) => {
      if (option.value === "") return

      const allowed = !videoOnly || this.videoSamplePlatformsValue.includes(option.value)

      option.hidden = !allowed
      option.disabled = !allowed

      if (!allowed && option.selected) {
        this.platformTarget.value = ""
      }
    })
  }
}
